<template>
	<Modal width="700px">
		<template #modal-title>
			<span class="title">
				Create New Action Link
			</span>
			<v-spacer />
			<IconButton
				data-testid="close-button"
				@click="$emit('close')"
			>
				mdi-close
			</IconButton>
		</template>

		<template #modal-content>
			<p class="subtitle-1 text--secondary mb-6 text-center">
				Choose how you want to use this action link
			</p>

			<v-row class="justify-center">
				<v-col
					cols="12"
					sm="6"
					class="d-flex"
				>
					<OverviewCard
						title="Action Link"
						description="A regular link that can be included in your email content or on a webpage."
						icon="mdi-file-document-outline"
						use-grey
						data-testid="action-link-option"
						@overview="$emit('select', { isOneClickUnsubscribe: false })"
					/>
				</v-col>

				<v-col
					cols="12"
					sm="6"
					class="d-flex"
				>
					<OverviewCard
						title="One-Click Unsubscribe Link"
						description="A link used in the email header to enable One-Click Unsubscribe functionality in supported email clients."
						icon="mdi-cog-outline"
						use-grey
						data-testid="one-click-unsubscribe-option"
						@overview="$emit('select', { isOneClickUnsubscribe: true })"
					/>
				</v-col>
			</v-row>
		</template>
	</Modal>
</template>

<script>
import Modal from '../../../../../../shared/components/modal.vue'
import IconButton from '../../../../../../shared/components/icon-button.vue'
import OverviewCard from '../../../../../../shared/components/overview-card.vue'

export default {
	name: 'action-link-type-selection-modal',
	components: {
		Modal,
		IconButton,
		OverviewCard
	}
}
</script>

<style scoped>
.title {
	font-size: 1.25rem;
	font-weight: 500;
}
</style>
